<template>
  <div class="modal-xm modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Изменение сокращённого названия</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="alert alert-success my-1" v-if="this.region">
        Текущее сокращённое название: {{this.region.short_name}}
      </div>
      <div v-if="regionData" class="modal-body">
        <input-form-custom
          name="shortName"
          v-model="regionData.shortName"
          label="Сокращённое название"
          class="mb-3"
          inputClass="form-control"
        />
      </div>
      <div class="alert alert-danger my-1" v-if="validationError">
        {{validationError}}
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <btn-action
          class="btn btn-primary"
          @click="save"
        >Изменить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import {pick, cloneDeep} from 'lodash'

  export default {
    props: ['region'],
    data () {
      return {
        regionData: {
            region: this.region
        },
        validationError: '',
        balance: 0,
      }
    },
    methods: {
      save () {
        this.balance = Number(this.regionData.count) + Number(this.region.money)
        api.post(`billing/regions/edit-short-name/`, {short_name: this.regionData.shortName, region_id: this.region.id})
        .then(({data}) => {
              this.hide(false)
              window.alert(`Сокращённое название изменено!`)
            })
        .catch(this.handleError)
      },
      hide (refresh = false) {
        this.$emit('hide', {
          refresh: refresh,
        })
      },
      handleError (error) {
        if (error.response && error.response.status === 422) {
          let obj = error.response.data.validation
          this.validationError = obj[Object.keys(obj)[0]][0]
        } else {
          throw error
        }
      },
    },
    mounted () {
      if (this.user) {
        this.regionData = pick(this.user, ['count'])
      } else {
        this.regionData = {
            count: '',
          }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/billing/modals/region-edit-short-name.vue